import '../../../../../../node_modules/glightbox/dist/css/glightbox.min.css';
import './Styles.scss'
import GLightbox from 'glightbox';

(() => {
    const galleries = document.querySelectorAll('[data-gallery]')

    if (galleries) {
        galleries.forEach(gallery => {
            const lightbox = GLightbox({
                selector: '[data-gallery="' + gallery.dataset.gallery + '"]',
                loop: false
            })
        })
    }
})();
